export type ShipdayIntegrationType = 'merchant' | 'location'

export type ShipdayIntegration = {
  id: string
  webhook_token: string
  location_ids: string[] | null
}

export type ShipdayConnection = {
  id: string
  token: string
  integrationType: ShipdayIntegrationType
  connectedStoreIds: string[]
}

export type ValidationResult = {
  webhook_uuid: string
  webhook_url: string
  webhook_token: string
}

export const toShipdayConnection = (
  integration: ShipdayIntegration
): ShipdayConnection => ({
  id: integration.id,
  token: integration.webhook_token,
  integrationType:
    integration.location_ids && integration.location_ids.length > 0
      ? 'location'
      : 'merchant',
  connectedStoreIds: integration.location_ids ?? []
})
